import { Paper, Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import LensProductItem from "./lens-product-item";

export const LensProductSection = ({ note, salesRequestProductVariants }) => {
  if (!salesRequestProductVariants.length) return null;

  // Get the product name from the first variant
  const firstProductVariant =
    salesRequestProductVariants[0]?.purchaseOrderProductVariant;
  const productName = firstProductVariant?.product?.name || "-";

  // Parse addOn from note if exists
  let addOn = null;
  if (firstProductVariant?.note) {
    try {
      const descObj = JSON.parse(firstProductVariant.note);
      addOn = descObj.addOn || null;
    } catch {
      // ignore
    }
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Produk Lensa</Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2
            }}>
            <Typography variant="body2">1. {productName}</Typography>
            {addOn && (
              <Typography variant="body2" color="primary" sx={{
                fontWeight: "500"
              }}>
                Add On: {addOn}
              </Typography>
            )}
          </Box>
          <LensProductItem
            salesRequestProductVariants={salesRequestProductVariants}
          />
        </Grid>
        <Typography variant="body2">
          <span style={{ color: "gray" }}>Note: </span>
          {note ?? "-"}
        </Typography>
      </Grid>
    </Paper>
  );
};

LensProductSection.propTypes = {
  note: PropTypes.string,
  salesRequestProductVariants: PropTypes.array.isRequired,
};
